module.exports = __webpack_public_path__ + "img/project-adaptive-3.png?47419fae1db1bc380b7d95be8495ae78";